"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InversifyContainerErrorKind = void 0;
var InversifyContainerErrorKind;
(function (InversifyContainerErrorKind) {
    InversifyContainerErrorKind[InversifyContainerErrorKind["invalidOperation"] = 0] = "invalidOperation";
})(InversifyContainerErrorKind || (exports.InversifyContainerErrorKind = InversifyContainerErrorKind = {}));
//# sourceMappingURL=InversifyContainerErrorKind.js.map